import Cache from "../Cache.js";

/**
 * keyFigureComponentCache is a named instance of cache, to which we keep a
 * reference. It caches all keyFigure components that are not keyFigures.
 */
export default new Cache();
